<template>
    <Card>
        <div>

            <div class="multiple">
                <div class="child-div">时间区间</div>
                <RadioGroup v-model="timePeriod">
                    <Radio label="0"><span>不限</span></Radio>
                    <Radio label="1"><span>今日</span></Radio>
                    <Radio label="2"><span>昨日</span></Radio>
                    <Radio label="3"><span>本周</span></Radio>
                    <Radio label="4"><span>上周</span></Radio>
                    <Radio label="5"><span>本月</span></Radio>
                    <Radio label="6"><span>上月</span></Radio>
                    <Radio label="7"><span>自定义</span></Radio>
                    <DatePicker v-show="timePeriod == '7' " :value="timePeriodDate" @on-change="timePeriodDateChange"
                                type="daterange"
                                placeholder="选择日期" style="width: 200px"></DatePicker>
                </RadioGroup>
            </div>
            <div class="multiple">
                <div class="child-div">媒体选择</div>
                <div class="child-div">城市选择</div>
                <Select v-model="city" style="width:200px">
                    <Option v-for="item in cityList" :value="item.city" :key="item.city">{{ item.city }}</Option>
                </Select>
				<Button  type="primary" style="margin-left: 10px;" @click="getList">搜索</Button>
				<Button type="primary" style="margin-left: 20px;" @click="initSearch">重置刷新</Button>
            </div>
            <div >


            </div>
            <div style="width: 100% ;margin-top: 20px;">
                <Table :columns="columns" :data="datas"  ref="table">
                    <template slot-scope="{ row }" slot="name">
                        <div style="display: flex; align-items: center;">
                            <div v-if="row.type == 1 "
                                 style="width: 20px; height: 20px; line-height: 20px; background-color: #14BD98; color: #FFFFFF; border-radius: 50%; text-align: center">
                                个
                            </div>
                            <div v-if="row.type == 2 "
                                 style="width: 20px; height: 20px; line-height: 20px; background-color: #0C92F4; color: #FFFFFF; border-radius: 50%; text-align: center">
                                企
                            </div>
                            <div style="display: flex;flex-direction: column; align-items: center;">
                                <span>{{row.name}}</span>
                                <span>{{row.phone}}</span>
                            </div>
                        </div>
                    </template>
                </Table>
            </div>
            <div class="pager">
                <Page :total="count" :page-size="20" :current="page" @on-change="changePage" size="small" show-elevator/>
            </div>
        </div>
    </Card>
</template>
<script>
    import {consumptionReport} from "../../api/finance";
    import {mapGetters} from "vuex";
    import {getAllMedium, getAllMediumCode} from "../../api/runSet";

    export default {
        name: "consumptionReport",
        components: {},

        data() {
            return {
                page: 1,
                count: 0,
                name: '',
                timePeriod: '5',
                timePeriodDate: [],
                mediaChannel: 0,
                mediaValue: 0,
                cityList: [],
                mediaValueList: [],
                datas: [
                ],
                columns: [
                    {
                        "title": "消耗日期",
                        "key": "day",
						align: 'center'
                    },
                    {
                        "title": "城市",
                        "key": "city",
						align: 'center'
                    },
                    {
                        "title": "消耗金额",
                        "key": "cost",
						align: 'center'
                    },
					{
					    "title": "数量",
					    "key": "num",
						align: 'center'
					},
					{
					    "title": "分发数量",
					    "key": "success_num",
						align: 'center'
					},
					{
					    "title": "投放成本",
					    "key": "average_cost",
						align: 'center'
					},
					{
					    "title": "分发成本",
					    "key": "true_average_cost",
						align: 'center'
					},
					{
					    "title": "撞库率",
					    "key": "zhuangku_rate",
						align: 'center'
					},
                ]
            }
        },
        computed: {
            ...mapGetters(['token', 'userInfo'])
        },
        mounted() {
            this.loadData();
            this.getList();
        },
        methods: {
            timePeriodDateChange(e) {
                this.timePeriodDate = e
            },
            async loadData() {
                let that = this;
                let data = {
                    token: that.token
                };
                let res = await getAllMedium(that, data);
                this.mediaChannelList = res.data.list;
            },
			initSearch(){
				this.city = '';
				this.timePeriod = '5';
				this.getList();
			},
            changePage(e) {
                this.page = e;
                this.getList();
            },
            async getMediaValueList() {
                let that = this;
                let data = {
                    token: that.token,
                    medium_id: that.mediaChannel,
                };
                let res = await getAllMediumCode(that, data);
                this.mediaValueList = res.data.list;
            },
            async getList() {
                let that = this;
                let data = {
                    page: that.page,
                    token: that.token,
                    timePeriod: that.timePeriod,
                    timePeriodDate: that.timePeriodDate,
                    city: that.city,
                };
                let res = await consumptionReport(that, data);
                if (res.code == 1) {
                    that.datas = res.data.list;
                    that.count = res.count;
					that.cityList = res.data.cityList
                }
            },
        },


    }
</script>
<style scoped lang="less">

    .yellow_btn {
        color: #F8BD66;
    }

    .multiple {
        display: flex;
        justify-content: left;
        margin-top: 10px;
        align-items: center;

        .child-div {
            width: 70px;
            height: 20px;
            margin-right: 30px;
            text-align-last: justify;
        }
    }
	/deep/ .ivu-table th {
		background: #277dd3;
		color: white;
	}

	/deep/ .ivu-table .table-blue-row td {
		color: #ff6699;
	}

	/deep/ .ivu-table .table-yellow-row td {
		color: #aaaa00;
	}

	/deep/ .ivu-table .table-black-row td {
		color: black;
	}

    .sousuo {
        width: 100%;
        display: flex;
        justify-content: space-between;
    }

    .yl-flex {
        display: flex;
    }

    .flex_between {
        align-items: flex-start;
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
    }
</style>
